export const tooltipTokens = {
  tooltip: {
    root: {
      background: '{surface.1000}',
      color: '{surface.0}',
      borderRadius: '{borderRadius.sm}',
      padding: '1rem 1.5rem',
      minHeight: '3rem',
      arrowSize: '0.375rem'
    }
  }
};

export type TooltipTokens = typeof tooltipTokens;
